<template>
  <div class="indexWrap">
    <router-view></router-view>
    <van-tabbar v-model="active" route active-color="#538AE9" safe-area-inset-bottom>
      <van-tabbar-item class="color" to="/home">
        <span>好物</span>
        <img slot="icon" slot-scope="props" :src="props.active?homeSel:home" />
      </van-tabbar-item>
      <!-- <van-tabbar-item class="color" to="/shopCar">
        <span>购物车</span>
        <img slot="icon" slot-scope="propsTeam" :src="propsTeam.active?carSel:car" />
      </van-tabbar-item> -->
      <van-tabbar-item class="color" to="/myOrder">
        <span>订单</span>
        <img slot="icon" slot-scope="propNotice" :src="propNotice.active?orderSel:order" />
      </van-tabbar-item>
      <van-tabbar-item class="color" to="/personal">
        <span>我的</span>
        <img slot="icon" slot-scope="propPersonal" :src="propPersonal.active?mySel:my" />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
  import { Tabbar, TabbarItem } from "vant";
  export default {
    components: {
      [Tabbar.name]: Tabbar,
      [TabbarItem.name]: TabbarItem
    },
    data() {
      return {
        active: 0,
        homeSel: require('../assets/imgs/tabs/homeSel.png'),
        home: require('../assets/imgs/tabs/home.png'),
        carSel: require('../assets/imgs/tabs/carSel.png'),
        car: require('../assets/imgs/tabs/car.png'),
        orderSel: require('../assets/imgs/tabs/orderSel.png'),
        order: require('../assets/imgs/tabs/order.png'),
        mySel: require('../assets/imgs/tabs/mySel.png'),
        my: require('../assets/imgs/tabs/my.png')
      }
    }
  };
</script>
<style lang="less" scoped>
  .van-tabbar-item__text {
    color: #ccc;
    font-size: 13px;
  }

  .van-tabbar-item__icon {
    img {
      width: 22px;
      height: 22px;
    }

  }
</style>